<div class="card">
  <div class="card-body">
    <p class="h4 m-0">Ingressos combo</p>
    <p class="p text-secondary">
      Monte um pacote e escolha quantas unidades de cada ingresso entram nele. O comprador leva todos no mesmo
      pagamento, com estoque compartilhado.
    </p>

    @if (!hasEnoughIndividualTickets) {
      <p class="p text-secondary">
        Crie pelo menos um ingresso individual para disponibilizar um ingresso combo.
      </p>
    } @else if (combos.length === 0) {
      <p class="p text-secondary">Nenhum ingresso combo adicionado. Esta etapa é opcional.</p>
    } @else {
      <div class="container-combos">
        @for (combo of combos; track combo) {
          <div class="card card-combo">
            <div class="card-body p-3">
              <p class="h6">{{ combo.title }}</p>
              @if (comboLoteLabel(combo)) {
                <p class="p mb-1"><strong>{{ comboLoteLabel(combo) }}</strong></p>
              }
              <p class="p text-secondary">{{ componentNames(combo) }}</p>
              <p class="p mb-1"><strong>Preço</strong> {{ combo.price | currency: "BRL" }}</p>
              <p class="p mb-3"><strong>Cota</strong> {{ combo.quantity }}</p>
              <div class="d-flex gap-2">
                <app-button styleType="clean" icon="pi pi-pen-to-square" (btnClick)="openComboModal(combo)">
                  Editar
                </app-button>
                <app-button styleType="clean" icon="pi pi-trash" (btnClick)="removeCombo(combo)">Excluir</app-button>
              </div>
            </div>
          </div>
        }
      </div>
    }

    <div class="combo-step-actions mt-3">
      <app-button
        icon="pi pi-plus"
        styleType="secondary"
        [disabled]="!hasEnoughIndividualTickets"
        (btnClick)="openComboModal()">
        Novo ingresso combo
      </app-button>
    </div>
  </div>
</div>
